import { render, staticRenderFns } from "./amanuensisList.vue?vue&type=template&id=6fbfe326&scoped=true&"
import script from "./amanuensisList.vue?vue&type=script&lang=js&"
export * from "./amanuensisList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbfe326",
  null
  
)

export default component.exports